<div class="white-bg-overlay">&nbsp;</div>
<section class="page-wrapper bg-white scroll-container">
  <div class="d-flex">
    <div class="me-auto">
      <h1 class="page-title">Corporate Reports</h1>
    </div>
  </div>
  <hr />
  <ul *ngIf="authService.hasPermission('corporate_reports_ach_scan', 'R')">
    <!-- FIXME: list all company-wide reports to which the user has been granted access.-->
    <li><a routerLink="/reports/ach-scan">Nightly ACH Fraud Scan</a></li>
  </ul>
</section>
